"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "8",
  height: "8",
  viewBox: "0 0 8 8"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M1.58 1.38c-.52.23-.56.45-.56.49 0 .04.04.25.56.47.48.21 1.28.38 2.42.38s1.92-.17 2.4-.38c.48-.22.52-.42.52-.47 0-.06-.04-.27-.53-.49A5.99 5.99 0 004 1a6.2 6.2 0 00-2.42.38zm-.4-.91C1.83.17 2.77 0 4 0c1.22 0 2.15.17 2.8.47.63.29 1.12.76 1.12 1.4 0 .64-.49 1.1-1.12 1.39-.65.29-1.58.46-2.8.46a7.23 7.23 0 01-2.82-.46C.54 2.98.02 2.52.02 1.86c0-.64.52-1.11 1.15-1.4zM1 3.98a.5.5 0 00-1 .03c0 .27.14.52.3.71.17.21.41.42.73.6.65.36 1.6.63 2.97.63a6 6 0 002.97-.64c.32-.18.56-.39.73-.6.16-.19.3-.44.3-.7a.5.5 0 00-1-.04c0 .02-.02.05-.07.11-.08.1-.22.23-.46.36-.45.26-1.24.51-2.47.51a5.08 5.08 0 01-2.48-.5 1.57 1.57 0 01-.45-.36A.45.45 0 011 4zM.5 5.56c.27 0 .49.2.5.47 0 0 .02.05.07.1.08.1.22.23.45.36.46.26 1.25.5 2.48.5s2.02-.24 2.47-.5c.24-.13.38-.26.46-.36l.07-.1a.5.5 0 011 .03c0 .26-.14.51-.3.7-.17.21-.41.42-.73.6A6 6 0 014 8a6.05 6.05 0 01-2.97-.63 2.56 2.56 0 01-.73-.6c-.16-.2-.3-.45-.3-.71 0-.28.23-.5.5-.5z"
}));

exports["default"] = _default;